import React from 'react';
import PropTypes from 'prop-types';
import './Badge.css';

/**
 * CountBadge — the number beside a row's label or on an icon ("Sparade
 * designer ⬤4"): a gray-3 circle, P.Small gray-7, a pill past one digit.
 * Hidden at 0 unless `hideZero={false}`; capped at `max` ("99+").
 */
const CountBadge = ({ value, max = 99, hideZero = true, className = '' }) => {
  if (hideZero && !(value > 0)) return null;
  const text = value > max ? `${max}+` : String(value);
  return (
    <span className={['ds-count-badge', 'typo-body-sm', className].filter(Boolean).join(' ')}>{text}</span>
  );
};

CountBadge.propTypes = {
  value: PropTypes.number.isRequired,
  /** Values above it render as "max+" */
  max: PropTypes.number,
  /** Render nothing at 0 (default) */
  hideZero: PropTypes.bool,
  className: PropTypes.string,
};

export default CountBadge;
